/**
 * Device type enumeration
 */
export enum DeviceType {
    MOBILE = 'mobile',
    TABLET = 'tablet',
    IPAD = 'ipad',
    DESKTOP = 'desktop',
    UNKNOWN = 'unknown',
}

/**
 * Device orientation enumeration
 */
export enum DeviceOrientation {
    PORTRAIT = 'portrait',
    LANDSCAPE = 'landscape',
    UNKNOWN = 'unknown',
}

/**
 * Specific device models
 */
export enum DeviceModel {
    IPHONE = 'iphone',
    IPAD = 'ipad',
    ANDROID_PHONE = 'android-phone',
    ANDROID_TABLET = 'android-tablet',
    WINDOWS_TABLET = 'windows-tablet',
    DESKTOP = 'desktop',
    UNKNOWN = 'unknown',
}

/**
 * Device information interface
 */
export interface DeviceInfo {
    type: DeviceType;
    orientation: DeviceOrientation;
    model: DeviceModel;
    isTouch: boolean;
    isMobile: boolean;
    isTablet: boolean;
    isDesktop: boolean;
    isIpad: boolean;
    screenWidth: number | null;
    screenHeight: number | null;
    userAgent?: string;
}

/**
 * Breakpoint configuration
 */
export interface Breakpoints {
    mobile: number;
    tablet: number;
    desktop: number;
    ipadMin: number;
    ipadMax: number;
}

/**
 * Default breakpoints (in pixels)
 */
export const DEFAULT_BREAKPOINTS: Breakpoints = {
    mobile: 640,
    tablet: 1024,
    desktop: 1280,
    ipadMin: 768,
    ipadMax: 1024,
};

/**
 * Props for device-aware components
 */
export interface DeviceAwareProps {
    deviceInfo?: DeviceInfo;
    children?: React.ReactNode;
}

/**
 * Responsive section props
 */
export interface ResponsiveSectionProps extends DeviceAwareProps {
    className?: string;
    mobileLayout?: React.ReactNode;
    tabletLayout?: React.ReactNode;
    desktopLayout?: React.ReactNode;
    ipadLayout?: React.ReactNode;
}
